/* Modules */
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgxSpinnerModule } from 'ngx-spinner';

/* Custom Modules */
import { LoginModule } from './modules/login.module';

/* Components */
import { AppComponent } from './app.component';
import { VoucherRedeemedComponent } from './shared/voucher-redeemed/voucher-redeemed.component';

@NgModule({
  declarations: [
    AppComponent,
    VoucherRedeemedComponent,
  ],
  imports: [
    BrowserModule,
    LoginModule,
    NgxSpinnerModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
